import { defineComponent as _defineComponent } from 'vue'

import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzContainedButton, { type OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'
import { type ComponentPublicInstance, onMounted, ref } from 'vue'

export interface OzBaseDialogBoxButtonData {
  text: string
  emit: string
  colorScheme: OzContainedButtonColorScheme
  testId?: string
  disabled?: boolean
  isFocusedOnLoad?: boolean
}

export { OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'
const __default__ = {}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzBaseDialogBox',
  props: {
    buttons: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    forceFullWidthButtons: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { buttons: OzBaseDialogBoxButtonData[], darkMode: boolean | 'auto', forceFullWidthButtons: boolean }



const buttonWrapperRefs = ref<Record<string, HTMLDivElement>>({})
const setButtonWrapperRef = (
  buttonWrapperInstance: HTMLDivElement | ComponentPublicInstance | null,
  buttonWrapperIndex: string,
): void => {
  buttonWrapperRefs.value[buttonWrapperIndex] = buttonWrapperInstance as HTMLDivElement
}

onMounted((): void => {
  props.buttons.forEach((button, index) => {
    if (button.isFocusedOnLoad) {
      buttonWrapperRefs.value[index]?.children[0]?.focus()
    }
  })
})

return { __sfc: true,props, buttonWrapperRefs, setButtonWrapperRef, OzBox, OzBoxColors, OzContainedButton }
}

})